<div [formGroup]="formGroup">
  <label>Event Category Key Name:</label>
  <input nz-input formControlName="propertyKey" style="margin-bottom: 16px;" />

  <nz-table
    [nzData]="assetListArray.controls"
    [nzBordered]="true"
    [nzSize]="'middle'"
    [nzPagination]="false"
    [nzShowPagination]="false"
  >
    <thead>
      <tr>
        <th>Index</th>
        <th>Asset ID</th>
        <th>Order</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let group of assetListArray.controls; let i = index" [formGroup]="group">
        <td>#{{ i }}</td>
        <td><input nz-input formControlName="id" /></td>
        <td><input nz-input formControlName="order" type="number" /></td>
        <td>
          <button nz-button nzType="link" nzDanger (click)="removeAssetRow(i)">
            <i class="fas fa-fw fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div style="margin-top: 16px;">
    <button type="button" nz-button nzType="dashed" (click)="addAssetRow()">Add Asset</button>
  </div>
</div>
